const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Quiz Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Quizzes} Quizzes injected to gain access to the Quizzes resource
 */
app.controller('editQuiz', ['Application', 'Authorization', 'Analyze', 'Quizzes', '$scope', '$translate', function (Application, Authorization, Analyze, Quizzes, $scope, $translate) {
  var self = this;
  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;
  self.autoDuration = true;
  self.editSaved = true;
  self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
  self.denied = false;
  var locationChange = $scope.$on('$locationChangeStart', function(event) {
    if (self.editSaved) {
      // Allow the route change to progress
      locationChange();
      Application.messaging.clearMessages('trackstate');
      return;
    }

    // Halt the route change and question the action
    self.navigationPath = {};
    self.navigationPath.targetPath = Application.navigation.getPath();
    self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
    self.navigationPath.targetHash = Application.navigation.getHash();

    event.preventDefault();
    self.showDeparture = true;
    self.onLocationChange = function() {
      locationChange();
      Application.messaging.clearMessages('trackstate');
    };
  });
  var routeParameters = Application.navigation.getRouteParameters();
  var trackState = Application.trackState.get();
  if (trackState && trackState.ttl < new Date().valueOf()) {
    trackState = self.trackState = false;
  }
  self.newQuiz = routeParameters.id === 'new' || !routeParameters.id;
  if (trackState) {
    Application.messaging.addMessage({type: 'insidetrack', text: 'You are ' + (self.newQuiz ? 'adding' : 'editing') + ' a quiz ' + (self.newQuiz ? 'to' : 'in') + ' the ' + trackState.trackTitle + ' learning track. Click here to cancel and return.', trackstate: true, link: '/edit/tracks/' + trackState.track});
  }

  var quiz = {};
  quiz.min_pass = 0;
  quiz.retake = 0;
  quiz.duration = 0;
  quiz.show_results = false;
  quiz.explore_hide = true;
  quiz.questions = [];
  quiz.privacy_collaborators = [];
  self.showCollaborators = false;

  self.activeTab = 'details';
  self.currentEdit = null;
  self.previousQuestion = null;
  self.yesResults = false;
  self.noResults = true;
  self.yesRetake = false;
  self.noRetake = true;

  self.retakeValues = [];
  self.passValues = [];
  self.passValue = 0;
  self.mediumOpts = {
    'targetBlank': true,
    'toolbar': {
      'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
    }
  };

  self.navigationDirectory = {
    'details': {
      next: 'questions',
      previous: null,
      required: ['title']
    },
    'questions': {
      next: 'settings',
      previous: 'details',
      required: null
    },
    'settings': {
      next: null,
      previous: 'questions',
      required: null
    }
  };

  self.updateDuration = function() {
    if (!self.autoDuration) {
      return;
    }
    // Estimation is 30 seconds per question.
    self.quiz.duration = self.quiz.questions.length * 30;
  };

  // -------- Begin Questions Tab related JS --------
  self.addQuestion = function() {
    self.previousQuestion = null;
    var letters = ['a', 'b', 'c', 'd'];
    var q = {
      question: '',
      number: self.quiz.questions.length + 1,
      answers: []
    };
    angular.forEach(letters, function(letter) {
      q.answers.push({
        answer: '',
        letter: letter,
        correct: false
      });
    });
    self.quiz.questions.push(q);
    self.currentEdit = q.number;
  };

  self.validateCurrent = function(type, question) {
    var question;
    var answer;
    var hasCorrect;
    var end = function() {
      if (type === 'add') {
        self.addQuestion();
      } else if (type === 'edit' && question) {
        self.previousQuestion = JSON.parse(JSON.stringify(question));
        self.questionEdit = true;
        self.currentEdit = question.number;
      } else if (type === 'create') {
        if (self.currentEdit) {
          Application.messaging.addMessage({type: 'error', text: 'Please add or cancel the open question.', duration: 5});
          return;
        }
        self.createQuiz();
      } else if (type === 'update') {
        if (self.currentEdit) {
          Application.messaging.addMessage({type: 'error', text: 'Please add or cancel the open question.', duration: 5});
          return;
        }
        self.saveProgress();
      } else if (type === 'settings') {
        if (self.currentEdit) {
          Application.messaging.addMessage({type: 'error', text: 'Please add or cancel the open question.', duration: 5});
          return;
        }
        self.activeTab = 'settings';
        Application.scrollTop();
      } else if (!type) {
        self.updateDuration();
        self.questionEdit = false;
        self.currentEdit = null;
      }
    };

    if (!self.currentEdit) {
      end();
      return;
    }

    for (var i = 0; i < self.quiz.questions.length; i++) {
      if (self.currentEdit === self.quiz.questions[i].number) {
        question = self.quiz.questions[i];
        break;
      }
    }

    if (!question.question) {
      Application.messaging.addMessage({type: 'error', text: 'Please fill out the question text.', duration: 5});
      return;
    }

    if (!question.answers.length) {
      Application.messaging.addMessage({type: 'error', text: 'Please provide answers.', duration: 5});
      return;
    }

    for (var i = 0; i < question.answers.length; i++) {
      answer = question.answers[i];
      if (answer.correct) {
        hasCorrect = true;
      }

      if (!answer.answer) {
        Application.messaging.addMessage({type: 'error', text: 'Please fill out the text in all answers.', duration: 5});
        return;
      }
    }

    if (!hasCorrect) {
      Application.messaging.addMessage({type: 'error', text: 'Please choose a correct answer.', duration: 5});
      return;
    }

    end();
  };

  self.removeQuestion = function(index) {
    var number = self.quiz.questions[index].number;
    self.quiz.questions.splice(index, 1);
    angular.forEach(self.quiz.questions, function(question) {
      if (question.number > number) {
        question.number = question.number - 1;
      }
    });
    self.updateDuration();
    if (!self.quiz.questions.length) {
      self.addQuestion();
    }
  };

  self.cancelQuestion = function() {
    var index = null;
    for (var i = 0; i < self.quiz.questions.length; i++) {
      if (self.quiz.questions[i].number === self.currentEdit) {
        index = i;
        break;
      }
    }
    if (index === null) {
      return;
    }
    self.currentEdit = null;
    self.questionEdit = false;
    if (self.previousQuestion) {
      self.quiz.questions[index] = self.previousQuestion;
      self.previousQuestion = null;
      return;
    }
    self.removeQuestion(index);
  };
  // -------- End Questions Tab related JS --------


  // -------- Begin Settings Tab related JS --------

  // Pretty extensive to account for previous denomitations of 1 (now in 5s)
  self.setPassValues = function() {
    var reset;
    var currentLow = 0;
    var lowDiff = 100;

    var addValue = function(value) {
      self.passValues.push({
        name: value + '%',
        value: value
      });
    };

    var setCurrent = function(value) {
      currentLow = value;
    };

    if (!self.quiz.min_pass) {
      self.quiz.min_pass = 0;
    }

    reset = self.quiz.min_pass % 5 !== 0;
    for (var i = 0; i < 101; i = i + 5) {
      addValue(i);
      if (reset) {
        if (Math.abs(self.quiz.min_pass - i) < lowDiff) {
          lowDiff = Math.abs(self.quiz.min_pass - i);
          setCurrent(i);
        }
      }
    }
    if (reset) {
      self.quiz.min_pass = currentLow;
    }
  };

  // Sets retake values (iife)
  (function setRetakeOptions () {
    var addValue = function(value) {
      self.retakeValues.push({
        name: value,
        value: value
      });
    };
    for (var i = 1; i < 6; i = i + 1) {
      addValue(i);
    }
    self.retakeValues.push({
      name: 'Unlimited',
      value: 1000
    });
  }());

  self.showResults = function(yes) {
    if (yes) {
      self.noResults = !self.noResults;
      if (!self.noResults && !self.yesResults) {
        self.yesResults = true;
      }
    }
    if (!yes) {
      self.yesResults = !self.yesResults;
    }
    self.quiz.show_results = self.yesResults ? true : false;
  };

  self.allowRetake = function(yes) {
    if (yes) {
      self.noRetake = !self.noRetake;
      if (!self.noRetake && !self.yesRetake) {
        self.yesRetake = true;
      }
    }
    if (!yes) {
      self.yesRetake = !self.yesRetake;
    }

    if (self.yesRetake) {
      self.quiz.retake = self.quiz.retake || 1;
      return;
    }
    self.quiz.retake = 0;
  };
  // -------- End Settings Tab Related JS --------

  self.nextSection = function(item) {
    var nextClicked = item ? false : true;
    var item = item ? self.navigationDirectory[item].previous : self.activeTab;
    var next = self.navigationDirectory[item].next;
    var missing = '';
    var allow = true;

    var findIssues = function(check) {
      var current = self.navigationDirectory[check];
      if (current.required) {
        for (var i = 0; i < current.required.length; i++) {
          if (!self.quiz[current.required[i]]) {
            allow = false;
            missing = missing + ' ' + current.required[i] + ',';
          }
        }
      }
      if (current.previous) {
        findIssues(current.previous);
      }
    };

    findIssues(item);

    if (allow && next) {
      if (next === 'settings') {
        self.validateCurrent('settings');
        return;
      }
      self.activeTab = next;
      Application.scrollTop();
      return;
    }

    if (missing) {
      Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
    }
  };

  self.saveProgress = function() {
    if (!self.quiz._id) {
      return;
    }

    self.updateIndicator = true;
    self.quiz.summary = self.quiz.content;
    return Quizzes.update({
      subresource: self.quiz._id,
      fields: 'title,description,min_pass,questions,questions.answers,retake,show_results,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades'
    }, self.quiz).$promise.then(function(quiz) {
      Analyze.record({resource: 'modifications'}, {document: quiz._id, type: 'quiz'});
      Application.analyticsProvider.trackEvent('quiz_updated', {content: quiz._id, content_type: 'quiz', title: quiz.title});
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.quiz_saved'], duration: 5});
      self.editSaved = true;
      if (trackState) {
        Application.navigation.goTo('/edit/tracks/' + trackState.track);
      }
    }).catch(function(err) {
      console.log('Error in update: ', err);
    })
  };

  self.createQuiz = function() {
    if (!self.newQuiz || self.quiz._id) {
      return;
    }

    self.updateIndicator = true;
    self.quiz.user = self.user._id;
    self.quiz.summary = self.quiz.content;

    Quizzes.create(self.quiz).$promise
    .then(function(quiz) {
      Analyze.record({resource: 'creations'}, {document: quiz._id, type: 'quiz'});
      Application.analyticsProvider.trackEvent('quiz_created', {content: quiz._id, content_type: 'quiz', title: quiz.title})
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.quiz_created'], duration: 5});
      self.editSaved = true;
      if (trackState) {
        trackState.contentId = quiz._id;
        trackState.contentTitle = quiz.title;
        Application.trackState.set(trackState);
        Application.navigation.goTo('/edit/tracks/' + trackState.track);
        return;
      }
      Application.navigation.goTo('/view/quizzes/' + quiz._id);
    }).catch(function(err) {
      console.log('Error in update: ', err);
    });
  };

  self.goBack = function() {
    if (!self.denied || !self.backLocation) {
      Application.navigation.back();
      self.denied = true;
      return;
    }
    self.denied = true;
    var location = self.backLocation.split('/#/');
    if (location.length !== 2) {
      Application.navigation.back();
      return;
    }
    Application.navigation.goTo(location[1]);
  };

  self.initialize = function () {
    if (!Authorization.hasValidAuthToken()) {
      if (Application.navigation.isRouteSecure()){
        Application.navigation.goToSignIn();
      }
    }

    if (self.newQuiz) {
      // set initial state of quiz
      self.quiz = quiz;
      if(self.user.is_collaborator) {
        self.quiz.privacy_collaborators.push(self.user._id);
      }
      self.setPassValues();
      self.addQuestion();
      self.startEditWatch();
      return;
    }

    Quizzes.get({
      subresource: routeParameters.id,
      fields: 'title,company,description,min_pass,questions,questions.answers,retake,show_results,duration,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades'
    }, function (data) {
      if ((data.company !== self.authtoken.company._id) || (self.user.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.quizNotEditable'], duration: 5});
        self.editSaved = true;
        Application.navigation.goToHome();
      }
      self.quiz = data;
      if(!self.quiz.privacy_collaborators) {
        self.quiz.privacy_collaborators = [];
      }
      if(self.quiz.privacy_collaborators.length && !self.user.is_collaborator) {
        self.showCollaborators = true;
      }
      self.setPassValues();
      if (self.quiz.show_results) {
        self.showResults(true);
      }
      if (self.quiz.retake) {
        self.allowRetake(true);
      }
      self.startEditWatch();
    }, function (error) {
      console.log('Error occured getting quiz ', routeParameters.id, error);
      Application.notifications.setError('Unable to get quiz.');
    });
  };
  self.startEditWatch = function() {
    $scope.$watch('quiz.quiz', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.editSaved = false;
    }, true);
  };
  $translate([
    'edit.general.notification_fieldsMissing',
    'edit.general.notification_titleMissing',
    'edit.general.notification_confirmLeave',
    'modules.notifications.quiz_created',
    'modules.notifications.quiz_saved',
    'modules.notifications.quizNotEditable']).then(function(translations){
    self.translations = translations;
    self.initialize();
  });
}]);
